/** Convert raw provider error messages to user-friendly Russian text.
 *
 * Unknown errors intentionally get a generic fallback — we never want raw
 * provider stack traces or debug dumps leaking to users.
 */
export function humanizeGenerationError(raw?: string | null): { title: string; message: string; isCreditsError?: boolean } {
    const msg = (raw || '').toLowerCase();

    if (msg.includes('nsfw') || msg.includes('content_policy') || msg.includes('content policy') || msg.includes('safety') || msg.includes('moderation') || msg.includes('prohibited use policy') || msg.includes('filtered out because it violated')) {
        return {
            title: 'Контент не прошёл модерацию',
            message: 'Запрос или результат не прошли проверку безопасности. Попробуйте изменить промпт.'
        };
    }
    if (msg.includes('insufficient') && (msg.includes('credits') || msg.includes('balance'))) {
        return {
            title: 'Недостаточно кредитов',
            message: 'Пополните баланс, чтобы продолжить генерацию.',
            isCreditsError: true
        };
    }

    return {
        title: 'Произошла ошибка',
        message: 'Попробуйте чуть позже. Кредиты возвращены на баланс.'
    };
}
